import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["roleRadio", "permissionsSection"];

  connect() {
    this.togglePermissions();
  }

  togglePermissions() {
    if (this.roleRadioTargets.length === 0) return; // edit 모드: 서버 렌더링 신뢰

    const selectedRole = this.roleRadioTargets.find(
      (radio) => radio.checked,
    )?.value;
    const isStaff = selectedRole === "staff";

    if (this.hasPermissionsSectionTarget) {
      this.permissionsSectionTarget.classList.toggle("hidden", !isStaff);
    }
  }

  roleChanged() {
    this.togglePermissions();
  }
}
